export enum EVENT_TYPE {
	AUCTION_ONLINE = 'Auction online',
	AUCTION_OFFLINE = 'Auction offline',
}

export enum EVENT_IMAGE {
	EVENT = 'Event',
	SPONSOR = 'Sponsor',
	RAFFLE = 'Raffle',
}

export enum EMAIL_TEMPLATE_TYPE {
	TICKET_INVOICE = 'TicketInvoice',
	INVOICE_EMAIL = 'InvoiceEmail',
	PAYMENT_ACKNOWLEDGEMENT = 'PaymentAcknowledgement',
	TICKET_PAYMENT_CONFIRMATION = 'TicketPaymentConfirmation',
	PATRON_UPDATE = 'PatronUpdate',
	TABLE_UPDATE = 'TableUpdate',
	CONTRIBUTIONS_SUMMARY = 'ContributionsSummary',
	AUCTION = 'Auction',
	INVOICES = 'Invoices',
}
